import * as React from 'react';
import { Vas16 } from '@cian/ui-kit/icons';
import * as styles from './Autobroker.css';
import { InlineText1 } from '@cian/ui-kit';

interface IAutobrokerProps {
  strategyName: string;
}

export const Autobroker = ({ strategyName }: IAutobrokerProps) => {
  return (
    <div className={styles['wrapper']}>
      <div className={styles['icon']}>
        <Vas16 color="warning_100" />
      </div>

      <div className={styles['message']}>
        <InlineText1>{strategyName}</InlineText1>
      </div>
    </div>
  );
};
